import React, { useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm, Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Fetch } from "../../shared/Fetch";

export interface IForm {
    open: boolean;
    singleData: any;
    reload: boolean;
    setReload: React.Dispatch<React.SetStateAction<boolean>>;
    hideDialog: () => void;
    toast: any;
}

const schema = yup.object({
    groupName: yup.string().required("Group Name is required")
});

export const Form = ({
    open,
    singleData,
    reload,
    setReload,
    hideDialog,
    toast
}: IForm) => {

    const { control, handleSubmit, reset } = useForm({
        resolver: yupResolver(schema),
        defaultValues: { groupName: "" }
    });

    useEffect(() => {
        if (singleData?.groupName) {
            reset({ groupName: singleData.groupName });
        } else {
            reset({ groupName: "" });
        }
    }, [singleData, reset]);

    const onSubmit = async (data: any) => {
        const isEdit = !!singleData?.id;
        const method = isEdit ? "PUT" : "POST";
        const url = isEdit ? "updateGroup" : "saveGroup";
        const message = isEdit ? "Updated Successfully" : "Added Successfully";

        const payload = {
            ...data,
            id: singleData?.id
        };

        const response = await Fetch( `Company_Grouping/${url}`, method, payload, null, toast );

        if (response) {
            toast.current?.show({
                severity: "success",
                summary: "Success",
                detail: message,
                life: 3000
            });

            setReload(prev => !prev);
            hideDialog();
        }
    };

    return (
        <Dialog visible={open} onHide={hideDialog} header="Add / Edit Group" modal style={{ width: "30vw" }}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">

                <div className="field">

                    <label> Group Name <span className="text-red-500">*</span> </label>

                    <Controller name="groupName" control={control} render={({ field, fieldState }) => (
                        <>
                            <InputText {...field} placeholder="Enter Group Name" className={fieldState.error ? "p-invalid" : ""} />
                            {fieldState.error && (
                                <small className="p-error">{fieldState.error.message}</small>
                            )}
                        </>
                    )}
                    />
                </div>

                <div className="flex justify-content-end gap-3 mt-4">
                    <Button label="SAVE" type="submit" />
                    <Button label="CLOSE" type="button" className="p-button-outlined" onClick={hideDialog} />
                </div>
            </form>
        </Dialog>
    );
};

